/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * logicomix-api
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query'
import type {
  YoutubeQuotaSnapshotAttributesApiDTO
} from './Api.schemas'
import { customInstance } from '../AxiosInstance';
import type { ErrorType } from '../AxiosInstance';




/**
 * Latest known usage for each YouTube API daily quota (one entry per quota
metric, sorted by usage descending).
 */
export const getApiYoutubeQuotasLatest = (
    
 signal?: AbortSignal
) => {
      
      
      return customInstance<YoutubeQuotaSnapshotAttributesApiDTO[]>(
      {url: `/api/youtubeQuotas/latest`, method: 'GET', signal
    },
      );
    }
  

export const getGetApiYoutubeQuotasLatestQueryKey = () => {
    return [`/api/youtubeQuotas/latest`] as const;
    }

    
export const getGetApiYoutubeQuotasLatestQueryOptions = <TData = Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>, TError, TData>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiYoutubeQuotasLatestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>> = ({ signal }) => getApiYoutubeQuotasLatest(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>, TError, TData> & { queryKey: QueryKey }
}

export type GetApiYoutubeQuotasLatestQueryResult = NonNullable<Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>>
export type GetApiYoutubeQuotasLatestQueryError = ErrorType<unknown>

export const useGetApiYoutubeQuotasLatest = <TData = Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getApiYoutubeQuotasLatest>>, TError, TData>, }

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getGetApiYoutubeQuotasLatestQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



